@if (language && countryShort) {
    <sew-ws-social-media
        [text]="headline"
        [language]="language.toUpperCase()"
        [caasBaseUrl]="caasBaseUrl"
        [countryCode]="countryShort"
    ></sew-ws-social-media>
}
